module.exports = __webpack_public_path__ + "static/img/4567.f445c02f.png";